import React from 'react';

import {
  Box,
  Button,
  Card,
  Column,
  Columns,
  Heading,
  Hidden,
  Stack,
  Text,
} from '@origin-digital/ods-core';
import { IconChevronRightSmall } from '@origin-digital/ods-icons';
import { AppStoreBadge } from '@origin-digital/ods-lab';
import { IApp } from '../../models/content.interfaces';
import { kebabCase } from '../../utils/utils';
import { APPSTORE_PREFIX } from '../../consts/tracking';
import { CLOUDINARY_ENDPOINT } from '../../consts/config';
import { AppImage } from './AppImage';
import { QRCode } from './QRCode';

export const App = ({ heading, description, image, qrCode, label, url }: IApp) => {
  const imageSrc = `${CLOUDINARY_ENDPOINT}/${image}`;
  const qrCodeSrc = `${CLOUDINARY_ENDPOINT}/${qrCode}`;
  return (
    <Columns collapseBelow="lg" space={{ xs: 'none', lg: 'medium' }}>
      <Column width="3/4">
        <Box backgroundColor="primary" borderRadius="medium">
          <Card
            backgroundColor="transparent"
            paddingTop={{ xs: 'xxlarge' }}
            paddingXSpecific={{ xs: 'large', sm: 'xlarge', lg: 'xxlarge' }}
            paddingBottom="none"
          >
            <Columns
              collapseBelow="md"
              space={{ xs: 'xxlarge', md: 'xlarge', xl: 'xxlarge' }}
              alignY="center"
              direction="row-reverse"
            >
              <Column>
                <Box marginBottom={{ xs: 'none', md: 'xxlarge' }}>
                  <Stack space="xlarge">
                    <Stack space="large">
                      <Heading variant="h2" tone="white">
                        {heading}
                      </Heading>
                      <Stack space="xxsmall">
                        {description.map((item) => (
                          <Text variant="subtitle" tone="white" key={item}>
                            {item}
                          </Text>
                        ))}
                      </Stack>
                    </Stack>
                    <Stack space="none">
                      <Button
                        data-id={`${APPSTORE_PREFIX}-${kebabCase(label)}`}
                        href={url}
                        variant="text"
                        inverse
                        noTextPadding
                        size="large"
                        icon={<IconChevronRightSmall variant="solid" color="white" />}
                        iconPosition="trailing"
                      >
                        {label}
                      </Button>
                      <Hidden above="lg">
                        <Box marginTop="xlarge">
                          <AppStoreBadge />
                        </Box>
                      </Hidden>
                    </Stack>
                  </Stack>
                </Box>
              </Column>
              <Column width="content" alignX="center">
                <Box display="flex">
                  <AppImage dataId="app-image" imageSrc={imageSrc} />
                </Box>
              </Column>
            </Columns>
          </Card>
        </Box>
      </Column>
      <Column width="1/4" alignSelf="stretch">
        <Hidden below="lg">
          <Box display="flex" flexDirection="column" gap="medium" height="full">
            <Card
              backgroundColor="promoteC"
              paddingYSpecific={{ xs: 'none', lg: 'xlarge' }}
              alignItems="center"
            >
              <Stack alignX="center" space="none">
                <Box display="flex">
                  <QRCode dataId="app-qr-code" imageSrc={qrCodeSrc} />
                </Box>
              </Stack>
            </Card>
            <Card
              backgroundColor="promote"
              paddingYSpecific={{ xs: 'none', lg: 'xxlarge' }}
              alignItems="center"
            >
              <Box paddingY="xxsmall" width="full">
                <Stack alignX="center" space="none">
                  <AppStoreBadge alignment="stack" space="xsmall" />
                </Stack>
              </Box>
            </Card>
          </Box>
        </Hidden>
      </Column>
    </Columns>
  );
};
